module.exports = __webpack_public_path__ + "static/media/Discover.091e4717.svg";